export const buildId = item =>
  item &&
  `${item.fundId}:${item.investorId}:${item.documentTypeId}:${
    item.deliveryMethod
  }:${item.parameter || ''}`;
